<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<template>
  <div v-if="active" class="modal">
    <div class="modal_overlay" @click="$emit('update:active', false)" />
    <div class="modal_content">
      <div class="modal_header">
        <h2 class="modal_title">
          {{ title }}
        </h2>
        <button
          v-once
          type="button"
          class="modal_close"
          :title="$t('close')"
          @click="$emit('update:active', false)">
          <ion-icon name="close-outline" />
        </button>
      </div>
      <div class="modal_content_slot">
        <slot />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modal {
  position: fixed;
  z-index: 9999;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  &_overlay {
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.4);
  }

  &_content {
    display: flex;
    flex-direction: column;
    width: 90%;
    max-width: 640px;
    max-height: 90%;
    padding: 20px;
    border-radius: $radius;
    background: #fff;
    box-shadow: $shadow_base;

    &_slot {
      overflow-y: auto;
    }
  }

  &_header {
    flex: none;
    position: relative;
    margin-bottom: 20px;
    text-align: center;
  }

  &_title {
    font-size: 28px;
    font-weight: 700;
    color: map.get($colors,'black');
  }

  &_close {
    position: absolute;
    top: 0;
    right: 0;
    padding: 0;
    font-size: 28px;
    border: 0;
    background: none;
    cursor: pointer;
  }

  @include touch {
    align-items: flex-start;

    &_content {
      position: relative;
      top: 5%;
    }

    &_title {
      margin-top: 28px;
    }
  }
}
</style>
